const DOCUMENT = 'TALENT_CAREER_';

const actions = {
  CHANGE_INTEREST: DOCUMENT + 'CHANGE_INTEREST',
  CLEAR_INTEREST: DOCUMENT + 'CLEAR_INTEREST',
  CLEAR_STORE: DOCUMENT + 'CLEAR_STORE',
  CREATE_INTEREST_REQUEST: DOCUMENT + 'CREATE_INTEREST_REQUEST',
  DELETE_INTEREST_REQUEST: DOCUMENT + 'DELETE_INTEREST_REQUEST',
  LOAD_REQUEST: DOCUMENT + 'LOAD_REQUEST',
  LOAD_FORM_DATA: DOCUMENT + 'LOAD_FORM_DATA',
  LOAD_SUCCESS: DOCUMENT + 'LOAD_SUCCESS',
  TOGGLE_INTEREST_MODAL: DOCUMENT + 'TOGGLE_INTEREST_MODAL',
  UPDATE_INTEREST_REQUEST: DOCUMENT + 'UPDATE_INTEREST_REQUEST',

  changeInterest: payload => ({ type: actions.CHANGE_INTEREST, payload }),
  clearInterest: payload => ({ type: actions.CLEAR_INTEREST, payload }),
  clearStore: payload => ({ type: actions.CLEAR_STORE, payload }),
  createInterest: payload => ({ type: actions.CREATE_INTEREST_REQUEST, payload }),
  deleteInterest: payload => ({ type: actions.DELETE_INTEREST_REQUEST, payload }),
  loadData: payload => ({ type: actions.LOAD_REQUEST, payload }),
  loadDataSuccess: payload => ({ type: actions.LOAD_SUCCESS, payload }),
  loadFormData: payload => ({ type: actions.LOAD_FORM_DATA, payload }),
  toggleInterestModal: payload => ({ type: actions.TOGGLE_INTEREST_MODAL, payload }),
  updateInterest: payload => ({ type: actions.UPDATE_INTEREST_REQUEST, payload }),
};

export default actions;
